import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Public deployment facts, fetched once per page load:
 *   demo_mode   — is this a demo/preview deployment? gates every demo shortcut
 *   needs_setup — no platform admin exists yet, so /setup is still open
 */
let inflight = null;

export function fetchServerConfig() {
  if (!inflight) {
    inflight = api
      .get("/setup/status")
      .then((r) => r.data)
      .catch(() => ({ needs_setup: false, demo_mode: false }));
  }
  return inflight;
}

export function useServerConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchServerConfig().then((c) => alive && setCfg(c));
    return () => { alive = false; };
  }, []);
  return cfg;
}
